<script lang="ts" setup>
import NewRadioButton from '~/components/form-elements/NewRadioButton.vue'

defineProps<{
  label: string
  modelValue: boolean
}>()

const emit = defineEmits(['update:modelValue'])

function updateValue (value: boolean): void {
  emit('update:modelValue', value)
}
</script>

<template>
  <div class="mb-[28px] flex items-center justify-between">
    <div class="text-base font-medium leading-6 tracking-tight text-main-dark">
      {{ label }}
    </div>

    <NewRadioButton
      :label="null"
      :model-value="modelValue"
      :value="false"
      @update:model-value="updateValue"
    />
  </div>
</template>

